module.exports = __webpack_public_path__ + "static/media/rectus_femoris_right_weak.57830733.png";